export var RetailBusinessPlanMenuItems;
(function (RetailBusinessPlanMenuItems) {
    RetailBusinessPlanMenuItems["Download"] = "Download";
    RetailBusinessPlanMenuItems["Save"] = "Save";
})(RetailBusinessPlanMenuItems || (RetailBusinessPlanMenuItems = {}));
